import React from 'react';
import { ChevronDown } from 'lucide-react';
import { FAQ_ITEMS } from './tiersData';

// Accordion nativo via <details>/<summary> — zero JS overhead, a11y built-in.
// aria-expanded é gerenciado pelo browser automaticamente no <details>.
export const PricingFAQ: React.FC = () => {
  return (
    <section
      aria-labelledby="faq-heading"
      className="max-w-3xl mx-auto mb-16 sm:mb-20"
    >
      <h2
        id="faq-heading"
        className="text-2xl sm:text-3xl font-bold text-white text-center mb-8 sm:mb-10"
      >
        Perguntas frequentes
      </h2>

      <div className="space-y-3">
        {FAQ_ITEMS.map((item, index) => (
          <details
            key={index}
            className="group rounded-xl border border-neutral-700/50 bg-neutral-900/60 backdrop-blur-xl overflow-hidden"
          >
            <summary className="flex items-center justify-between gap-4 min-h-[56px] px-5 py-4 cursor-pointer list-none text-sm sm:text-base font-medium text-white hover:bg-neutral-800/40 transition-colors">
              <span>{item.question}</span>
              <ChevronDown className="w-5 h-5 text-neutral-400 flex-shrink-0 transition-transform group-open:rotate-180" />
            </summary>
            <div className="px-5 pb-5 pt-1 text-sm text-neutral-300 leading-relaxed border-t border-neutral-800/50">
              {item.answer}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
};
